import { debugWarn } from "./debug";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CACHE_KEY = "idb_estimate_config_v21";
let configPromise = null;
let resolved = null;

// Config already in hand (this session's cache or an earlier fetch) — lets the first render match the prerendered form.
export function peekEstimateConfig() {
  if (!resolved) {
    try { const cached = sessionStorage.getItem(CACHE_KEY); if (cached) resolved = JSON.parse(cached); } catch (e) { debugWarn("estimate config cache unreadable", e); }
  }
  return resolved;
}

export function getEstimateConfig() {
  if (!configPromise) {
    const cached = peekEstimateConfig();
    if (cached) configPromise = Promise.resolve(cached);
  }
  if (!configPromise) {
    configPromise = fetch(`${API}/estimate/config`).then((r) => {
      if (!r.ok) throw new Error("config");
      return r.json();
    }).then((c) => {
      resolved = c;
      try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(c)); } catch (e) { debugWarn("estimate config not cached (storage unavailable)", e); }
      return c;
    }).catch((e) => { configPromise = null; throw e; });
  }
  return configPromise;
}

export async function resolveZip(zip) {
  const r = await fetch(`${API}/estimate/region?zip=${encodeURIComponent(zip)}`);
  if (r.status === 429) throw new Error("rate");
  if (!r.ok) throw new Error("region");
  return r.json();
}

export async function geolocateZip(timeoutMs = 1500) {
  const ctrl = new AbortController();
  const timer = setTimeout(() => ctrl.abort(), timeoutMs);
  try {
    const r = await fetch("https://ipapi.co/json/", { signal: ctrl.signal });
    const j = await r.json();
    const zip = String(j?.postal || "").trim();
    return /^\d{5}$/.test(zip) && j?.country_code === "US" ? zip : null;
  } catch (e) {
    if (e?.name !== "AbortError") debugWarn("ZIP geolocation unavailable", e);
    return null;
  } finally {
    clearTimeout(timer);
  }
}
